import { Button, Card, Col, Container, Row } from "react-bootstrap";
import photo from './../../photos/2.png';
import './sectionTow.css';
function SectionThree(){
    return(
        <section id="section-tow">
            <Container id="section2">
                <Row id="main">
                    <Col lg={6}>
                        <h3>
                        We make everything by hand with the best possible ingredients.
                        </h3>
                        <p>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam et purus a odio finibus bibendum in sit amet leo. Mauris feugiat erat tellus.Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts.
                        </p>
                        <ul>
                            <li>Etiam sed dolor ac diam volutpat.</li>
                            <li>Erat volutpat aliquet imperdiet.</li>
                            <li>purus a odio finibus bibendum.</li>
                        </ul>
                        <Button id="section-tow-btn">Learn More</Button>
                    </Col>
                    <Col>
                    <Card.Img id="imge" src={photo} />
                    </Col>
                </Row>
            </Container>
        </section>
    )
}
export default SectionThree;